import React from 'react';
import moment from 'moment';
import TodayCashupRow from './TodayCashupRow';
import CashupTableRow from './CashupTableRow';

/**
 * Component for displaying the cashup table
 * @param {Object} props - Component props
 * @param {Array} props.cashups - Array of cashup objects
 * @param {Boolean} props.loading - Loading state
 * @param {Function} props.createTodayCashup - Function to create today's cash up
 * @param {Function} props.navigateToCashupDetail - Function to navigate to cashup detail
 */
const CashupTable = ({ cashups, loading, createTodayCashup, navigateToCashupDetail }) => {
  // Check if there's a cash up for the current date
  const today = moment().format('YYYY-MM-DD');
  const hasTodayCashup = cashups.some(cashup =>
    moment(cashup.date).format('YYYY-MM-DD') === today
  );

  return (
    <table className="cashup-table">
      <thead>
        <tr>
          <th style={{ width: '15%' }}>Status</th>
          <th style={{ width: '15%' }}>Date</th>
          <th style={{ width: '15%' }}>Cashed Up By</th>
          <th style={{ width: '20%' }}>Notes</th>
          <th style={{ width: '20%' }}>Last Edit</th>
        </tr>
      </thead>
      <tbody>
        {loading ? (
          <tr>
            <td colSpan="5" style={{ textAlign: 'center', padding: '20px' }}>
              Loading...
            </td>
          </tr>
        ) : cashups.length === 0 ? (
          <>
            <TodayCashupRow createTodayCashup={createTodayCashup} />
          </>
        ) : (
          <>
            {/* Show today's cashup row if no cashup exists for today */}
            {!hasTodayCashup && (
              <TodayCashupRow createTodayCashup={createTodayCashup} />
            )}
            
            {/* Map through existing cashups */}
            {cashups.map(cashup => (
              <CashupTableRow 
                key={cashup._id} 
                cashup={cashup} 
                navigateToCashupDetail={navigateToCashupDetail} 
              />
            ))}
          </>
        )}
      </tbody>
    </table>
  );
};

export default CashupTable;